<template>
    <div>
      <div class="col-md-12">
          <h3>Clientes da base</h3>
          <table id="relLog" ref='tabela' class="table display table-hover table-striped" style="width: 100%">
              <thead></thead>
              <tbody></tbody>
              <tfoot></tfoot>
          </table>
      </div>
  
      <component :is="comp" :data="compData" v-on:dismissModal="dismissModal" />
    </div>
  </template>
  
  <script>
  import modalCostumers from './ModalCostumers.vue';
  
  export default {
      components:{modalCostumers},
      props:{
          filter: {
              type: String,
              default: ''
          },
          upList: 0
      },
      data(){
          return {
              dt: null,
              val: this.filter,
              comp: '',
              compData: '',
              contactEquipeOption: '',
          }
      },
      watch:{
          upList: function(){
              this.createTable()
          },
          filter: {
              handler: function(val){
                  this.createTable()
              },
              deep: true
          }
      },
      methods:{
          dismissModal(){
              this.comp = '';
              this.createTable();
          },
          async createTable() {
          try {
              // Aguarde a resposta da API antes de continuar
              const { data } = await axios.get('/queue-contacts');
              this.contactEquipeOption = data;
  
              // Destruir a instância anterior do DataTable, se existir
              if (this.dt) {
                  $('#relLog').DataTable().destroy();
              }
  
              // Agora inicialize o DataTable
              this.dt = $('#relLog').DataTable({
                  processing: true,
                  serverSide: true,
                  destroy: true,
                  dom: '<"d-flex justify-content-between align-items-center mb-2"lBf>rtp',
                  lengthMenu: [10, 25, 50, 100],
                  
                  buttons: [
                    'excel',
                    'pdf',
                    {
                        text: 'Exportar Todos',
                        className: 'btn btn-success',
                        action: function (e, dt) {
                            const search = dt.search();
                            window.open(
                                '/customer_base/export-all',
                                '_blank'
                            );
                        }
                    }
                  ],

                  ajax: {
                      type: "GET",
                      url: '/customer_base/getclients'
                  },
                  columns: [
                      { "data": "company_name", 'title': 'Nome da empresa' }, 
                      { "data": "unique_key", className: 'text-center', 'title': 'CPF / CNPJ / ID' },
                      { "data": "name", 'title': 'Nome do Contato' }, 
                      { "data": "phone", className: 'text-center', 'title': 'Telefone' },
                      { "data": "email", className: 'text-center', 'title': 'Email' },
                      { "data": "department", className: 'text-center', 'title': 'Departamento' },
                      { "data": "division", className: 'text-center', 'title': 'Divisão' },
                      { 
                        "data": "status", 
                        className: 'text-center',
                        'title': 'Status', 
                        render: (data) => +data == 1 ? 'Ativo' : 'Inativo',
                      },
                      { "data": "filter", className: 'text-center', 'title': 'Grupo' },
                      { "data": "equipe", className: 'text-center', 'title': 'Fila',
                          render: (data) => {
                              if(data == null || data == ""){
                                  return "N/A";
                              }
                              return data;
                          }
                      },
                      { 
                          "data": "operator", 
                          className: 'text-center', 
                          'title': 'Consultor',
                          render: (data, type, row) => {
                              if (!data || !this.contactEquipeOption) return 'N/A';
  
                              let operadorNome = 'N/A';
  
                              // Itera sobre as filas e busca pelo operador
                              this.contactEquipeOption.forEach(fila => {
                                  const operadorEncontrado = fila.operadores.find(op => op.extension_line == data);
                                  if (operadorEncontrado) {
                                      operadorNome = operadorEncontrado.name;
                                  }
                              });
  
                              return operadorNome;
                          }
                      },
                      {
                          class: 'details-control find-data text-center',
                          data: 'id',
                          'title': 'Detalhes',
                          render: data => 
                              `<button type='button' class='find-data invisible-button detail-button'>
                                  <i class='find-data fa fa-search-plus'></i>
                              </button>`
                      }
                  ],
                  order: [[0, 'asc']]
              });
          } catch (error) {
              console.error("Erro ao carregar dados de filas: ", error);
          }
      }
  
      },
      mounted(){
          this.createTable();
  
          document.querySelector('#relLog tbody').addEventListener('click', (e) =>{
              
              if(e.target.classList.contains('find-data')){
                  const tr = e.target.closest('tr');
                  const row = this.dt.row( tr ).data();
                  this.compData = row;
                  this.comp = 'modal-costumers'
              }
  
          });
      }
  
  }
  </script>
  
  <style>
   .detail-button {
       font-size: 18px !important;
       color: #1c869a;
   }
  
   .detail-button:hover {
       color: #0c4955;
       transition: 0.5s;
   }
  </style>